import { DateRange } from '../date-ranges-input/date-ranges-input.component';
import { addDays } from 'date-fns';

export function getDatesFromRanges(ranges: DateRange[]): Date[] {
  return ranges.reduce((acc: Date[], range) => {
    return [...acc, ...getDatesInRange(range)];
  }, []);
}

function getDatesInRange(range: DateRange): Date[] {
  if (!range.from) {
    return [];
  }
  if (!range.to) {
    return [range.from];
  } else {
    let dates = [];
    let date = range.from;
    while (date <= range.to) {
      dates.push(date);
      date = addDays(date, 1);
    }
    return dates;
  }
}
